// Custom ADP route manifest.
import type { ManifestRouteDefinition } from '@/core/manifest/types'

export const adpManifestRoutes: ManifestRouteDefinition[] = [
  {
    key: 'adp',
    path: '/akashic-landing',
    isPublic: true,
    apiCalls: [],
    subFeatures: [
      {
        key: 'adp_landing_page',
        label: 'Adp Landing Page',
        apiCalls: [],
      },
      {
        key: 'adp_pipeline_page',
        label: 'Adp Pipeline Page',
        apiCalls: [],
      },
    ],

    lazyComponent: () =>
      import('@/features/adp/pages/akashic-landing-page/AkashicLandingPage').then((m) => ({
        default: m.default,
      })),
  },
  {
    key: 'adp_pipeline',
    path: '/akashic-data-pipeline',
    isPublic: true,
    apiCalls: [],
    lazyComponent: () =>
      import('@/features/adp/pages/data-pipeline-page/DataPipelinePage').then((m) => ({
        default: m.default,
      })),
  },
]
